import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { findIndex, slice } from "lodash";
import { SLIDE_NUMBER } from "../constants";

const [monthFrequency] = [4];

export async function getDefaultCalendarSelection(
  commodities: number[],
  calendarOriginItems: DictionaryItem[],
  dictionariesService: DictionariesService,
) {
  const lastCalendarDictionary = await dictionariesService.getDictionary({
    id: "slides-f-last-calendar",
    parameters: {
      commodities: commodities ? String(commodities.join(",")) : "120,12,13,18",
      slide: SLIDE_NUMBER,
    },
  });

  const lastCalendarItems = await lastCalendarDictionary.getAll();
  const sortedCalendarItems = calendarOriginItems.sort((a, b) => Number(a.id) - Number(b.id));

  const currentDate = new Date();
  const defaultLastMonthMark = Number(
    `${monthFrequency}${currentDate.getFullYear()}${currentDate.getMonth()}${currentDate.getDay()}`,
  );
  let calendarMark;

  if (lastCalendarItems.length > 0) {
    const [lastCalendarMark] = lastCalendarItems;
    const lastCalendarMarkIdx = findIndex(
      sortedCalendarItems,
      (item) => item.getValue<number>("id") === Number(lastCalendarMark.id),
    );

    const lastHalfYearMonths = slice(sortedCalendarItems, lastCalendarMarkIdx - 5, lastCalendarMarkIdx + 1);

    calendarMark = lastHalfYearMonths.map((item) => Number(item.id));
  } else {
    calendarMark = [defaultLastMonthMark];
  }

  return {
    calendar: calendarMark,
  };
}
